import '../../assets/index36.css';var W = Object.defineProperty, j = Object.defineProperties;
var E = Object.getOwnPropertyDescriptors;
var b = Object.getOwnPropertySymbols;
var F = Object.prototype.hasOwnProperty, N = Object.prototype.propertyIsEnumerable;
var $ = Math.pow, D = (t, o, e) => o in t ? W(t, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[o] = e, a = (t, o) => {
  for (var e in o || (o = {}))
    F.call(o, e) && D(t, e, o[e]);
  if (b)
    for (var e of b(o))
      N.call(o, e) && D(t, e, o[e]);
  return t;
}, p = (t, o) => j(t, E(o));
var R = (t, o) => {
  var e = {};
  for (var n in t)
    F.call(t, n) && o.indexOf(n) < 0 && (e[n] = t[n]);
  if (t != null && b)
    for (var n of b(t))
      o.indexOf(n) < 0 && N.call(t, n) && (e[n] = t[n]);
  return e;
};
import { jsx as h, jsxs as H } from "react/jsx-runtime";
import O, { useRef as U, useState as k, forwardRef as z } from "react";
import { ChevronUpFarFAIcon as B, ChevronDownFarFAIcon as I } from "../Icons/index.js";
import { f as q, u as V, b as G, B as P, c as J } from "../../factory-ueRxoNOV.js";
import { g as L } from "../../get-style-object-D6Nwi4P2.js";
import { flushSync as Q } from "react-dom";
import { u as X, a as Y } from "../../use-reduced-motion-C9DbPZfj.js";
import { m as Z } from "../../use-merged-ref-n551Tfbr.js";
function K(t) {
  if (!t || typeof t == "string")
    return 0;
  const o = t / 36;
  return Math.round((4 + 15 * $(o, 0.25) + o / 5) * 10);
}
function v(t) {
  return t != null && t.current ? t.current.scrollHeight : "auto";
}
const C = typeof window != "undefined" && window.requestAnimationFrame;
function tt({
  transitionDuration: t,
  transitionTimingFunction: o = "ease",
  onTransitionEnd: e = () => {
  },
  opened: n
}) {
  const l = U(null), u = 0, m = {
    height: 0,
    overflow: "hidden"
  }, [d, f] = k(n ? {} : m), c = (s) => {
    Q(() => f(s));
  }, r = (s) => {
    c((i) => a(a({}, i), s));
  };
  function _(s) {
    const i = t || K(s);
    return {
      transition: `height ${i}ms ${o}, opacity ${i}ms ${o}`
    };
  }
  X(() => {
    typeof C == "function" && C(n ? () => {
      r({ willChange: "height", display: "block", overflow: "hidden" }), C(() => {
        const s = v(l);
        r(p(a({}, _(s)), { height: s }));
      });
    } : () => {
      const s = v(l);
      r(p(a({}, _(s)), { willChange: "height", height: s })), C(() => r({ height: u, overflow: "hidden" }));
    });
  }, [n]);
  const g = (s) => {
    if (!(s.target !== l.current || s.propertyName !== "height"))
      if (n) {
        const i = v(l);
        i === d.height ? c({}) : r({ height: i }), e();
      } else d.height === u && (c(m), e());
  };
  function y(ct = {}) {
    var x = ct, { style: s = {}, refKey: i = "ref" } = x, M = R(x, ["style", "refKey"]);
    const A = M[i], S = p(a({
      "aria-hidden": !n
    }, M), {
      [i]: Z(l, A),
      onTransitionEnd: g,
      style: a(a({ boxSizing: "border-box" }, s), d)
    });
    return O.version.startsWith("18") ? n || (S.inert = "") : S.inert = !n, S;
  }
  return y;
}
const ot = {
  transitionDuration: 200,
  transitionTimingFunction: "ease",
  animateOpacity: !0
}, T = q((t, o) => {
  const i = V("Collapse", ot, t), {
    children: e,
    in: n,
    transitionDuration: l,
    transitionTimingFunction: u,
    style: m,
    onTransitionEnd: d,
    animateOpacity: f
  } = i, c = R(i, [
    "children",
    "in",
    "transitionDuration",
    "transitionTimingFunction",
    "style",
    "onTransitionEnd",
    "animateOpacity"
  ]), r = G(), _ = Y(), y = (r.respectReducedMotion ? _ : !1) ? 0 : l, s = tt({
    opened: n,
    transitionDuration: y,
    transitionTimingFunction: u,
    onTransitionEnd: d
  });
  return y === 0 ? n ? /* @__PURE__ */ h(P, p(a({}, c), { children: e })) : null : /* @__PURE__ */ h(
    P,
    p(a({}, s(a({
      style: a({
        opacity: n || !f ? 1 : 0,
        transition: f ? `opacity ${y}ms ${u}` : "none"
      }, L(m, r)),
      ref: o
    }, c))), {
      children: e
    })
  );
});
T.displayName = "@mantine/core/Collapse";
const et = "Collapse-module__root___W3SdU", nt = "Collapse-module__collapse___3a0Pg", st = "Collapse-module__content___DRM4-", it = "Collapse-module__button___vulV6", at = "Collapse-module__collapseContent___-FzyR", rt = "Collapse-module__card___cWWHo", w = {
  root: et,
  collapse: nt,
  content: st,
  button: it,
  collapseContent: at,
  card: rt
}, lt = z((_, r) => {
  var g = _, {
    "data-plum-id": t,
    children: o,
    in: e,
    transitionDuration: n = 200,
    transitionTimingFunction: l = "ease",
    animateOpacity: u = !0,
    label: m,
    onToggle: d,
    variant: f = "default"
  } = g, c = R(g, [
    "data-plum-id",
    "children",
    "in",
    "transitionDuration",
    "transitionTimingFunction",
    "animateOpacity",
    "label",
    "onToggle",
    "variant"
  ]);
  return /* @__PURE__ */ H("div", { className: J(w.root, w[f]), children: [
    /* @__PURE__ */ H(
      "button",
      {
        onClick: d,
        className: w.button,
        "data-collapse": "true",
        children: [
          m,
          e ? /* @__PURE__ */ h(B, {}) : /* @__PURE__ */ h(I, {})
        ]
      }
    ),
    /* @__PURE__ */ h(
      T,
      p(a({
        ref: r,
        in: e,
        transitionDuration: n,
        transitionTimingFunction: l,
        animateOpacity: u,
        className: w.root,
        "data-plum-id": t
      }, c), {
        children: /* @__PURE__ */ h("div", { className: w.collapseContent, children: o })
      })
    )
  ] });
});
lt.displayName = "Collapse";
export {
  lt as Collapse
};
